<template>
  <div class="py-2">
    <div class="container">
      <div class="row mt-0 mt-md-5">
        <div class="col-12 col-md-4">
          <div class="row">
            <div class="col-12 mb-3">
              <div class="dashboard-container">
                <div class="dashboard-container-header">
                  <div class="wfh-h4">Virtual Office</div>
                  <div
                    class="wfh-paragraph-md text-white"
                    style="font-size: 14px"
                  >
                    An overview of the people at your office.
                  </div>
                </div>
                <div class="dashboard-container-content">
                  <virtual-office-overview
                    :timezone="timezone"
                    v-if="loadVirtualOffice"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-8">
          <div class="row">
            <div class="col-12">
              <div class="dashboard-container">
                <div class="dashboard-container-header">
                  <div class="wfh-h4">Get Started</div>
                  <div
                    class="wfh-paragraph-md text-white"
                    style="font-size: 14px"
                  >
                    Invite team members, post a job and view matching candidates
                  </div>
                </div>
                <div class="dashboard-container-content">
                  <div class="row mx-0 mt-0 mb-4" style="width: 100%">
                    <div class="col-auto bullet">1</div>

                    <div class="col d-flex flex-column">
                      <h1 class="article-title d-flex align-items-center">
                        Add or invite your team member
                        <span class="badge" v-if="completedFirstStep"
                          ><CheckedRoundedIcon
                        /></span>
                      </h1>

                      <span class="article-sub mb-2"
                        >Insert your team member’s emails separated by
                        comma</span
                      >

                      <div class="mb-2">
                        <textarea
                          v-model="teamMembers"
                          id="teamMemberEmails"
                          class="form-control"
                          style="
                            resize: none;
                            border-radius: 0;
                            border: 1px solid #dce2ed;
                          "
                        ></textarea>
                      </div>

                      <div class="d-flex justify-content-end">
                        <button
                          @click="inviteTeamMembers"
                          class="wfh-btn-color-primary"
                          style="width: 80px; border-radius: 4px"
                        >
                          Send
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="row mx-0 mt-0 mb-4" style="width: 100%">
                    <div class="col-auto bullet">2</div>

                    <div class="col d-flex flex-column">
                      <h1 class="article-title d-flex align-items-center">
                        Get started with your recruitment
                        <span class="badge" v-if="completedSecondStep"
                          ><CheckedRoundedIcon
                        /></span>
                      </h1>

                      <span class="article-sub mb-2">
                        With simple few steps to get talented employees for you
                      </span>
                      <a
                        :href="getTribehiredPostJobUrl()"
                        class="
                          wfh-btn-primary wfh-btn-color-primary
                          d-flex
                          align-items-center
                          justify-content-center
                        "
                      >
                        Post New Job
                      </a>
                    </div>
                  </div>

                  <div class="row mx-0 mt-0 mb-4" style="width: 100%">
                    <div class="col-auto bullet">3</div>

                    <div class="col d-flex flex-column">
                      <h1 class="article-title d-flex align-items-center">
                        Custom modules in settings
                      </h1>
                      <span class="article-sub mb-2"
                        >Integrate recruitment, staff on-boarding and HR in a single system.</span
                      >
                      <a
                        style="padding-top: 15px"
                        :href="getModulePermissionsUrl()"
                        class="wfh-btn-primary wfh-btn-color-primary"
                        >Go to settings</a
                      >
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 py-4 px-5 d-flex justify-content-end">
                    <button
                      type="button"
                      @click="skipOnboarding"
                      class="wfh-btn wfh-btn-primary-outline"
                    >
                      Skip Onboarding
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import CheckedRoundedIcon from '../../icons/CheckedRoundedIcon'

export default {
  components: { CheckedRoundedIcon },
  data() {
    return {
      loadVirtualOffice: true,
      teamMembers: '',
      completedFirstStep: false,
      completedSecondStep: false,
    }
  },

  computed: {
    timezone() {
      return this.$store.state.timezone
    },

    currentUser() {
      return this.$store.state.currentUser
    },
  },

  watch: {
    currentUser() {
      if (this.currentUser.hasOwnProperty('completed_steps') && this.currentUser.completed_steps !== null) {
        this.completedFirstStep = this.currentUser.completed_steps.includes(1)
        this.completedSecondStep = this.currentUser.completed_steps.includes(2)
      }
    }
  },

  methods: {
    getModulePermissionsUrl() {
      return route('tribesuite.module-permissions')
    },

    getTribehiredPostJobUrl() {
      return route('redirect-tribehired-job-create')
    },

    async inviteTeamMembers() {
      const emailString = document.getElementById('teamMemberEmails').value

      const teamMemberEmails = emailString.split(",").map((email) => email.trim())

      try {
        await axios.post(route('team-members.add'), {
          emails: teamMemberEmails
        })

        Swal.fire({
          icon: 'success',
          title: 'Invitation emails has been sent',
        })

        this.loadVirtualOffice = false
        this.teamMembers = ''
        await this.$store.dispatch('setCurrentUser')

        this.loadVirtualOffice = true

      } catch (e) {
        console.log(e)
      }
    },

    async skipOnboarding() {
      try {
        await axios.post(route('onboarding.skip'))
        window.location.reload()
      } catch (e) {
        console.log(e)
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../sass/core/mixins";

.dashboard-container {
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);

  @include media-breakpoint-up(sm) {
    border-radius: 0 0 8px 8px;
  }
}

.dashboard-container-header {
  height: 128px;
  padding: 36px 21px 24px;
  background: linear-gradient(133.27deg, #0b1324 0%, #0f3266 100%);

  @include media-breakpoint-up(sm) {
    border-radius: 8px 8px 0 0;
  }

  .btn-expand {
    color: #fff;
    padding: 10px;
    position: absolute;
    top: 5px;
    right: 15px;
    cursor: pointer;
  }
}

.dashboard-container-content {
  padding: 24px 21px 11px;

  @include media-breakpoint-up(sm) {
    border-radius: 0 0 8px 8px;
  }
}

.bullet {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #0db4e6;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Avenir, sans-serif;
  font-weight: 900;
}

.article-title {
  color: #343a40;
  font-family: Avenir, sans-serif;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 28px;
  margin: 0 !important;
}

.article-sub {
  color: #808fa4;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
}
</style>
